import LsnContent from './lsn-content';

export default LsnContent;
